import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { frontloadConnect } from 'react-frontload';
import { getStaticPage, setStaticHTML } from '../../reducers';
import Page from '../../components/page';

const frontload = async props =>
  await props.getStaticPage(props.match.params.staticPage);

class StaticPages extends Component {
  constructor(props) {
    super(props);
  }

  componentWillUnmount() {
    this.props.setStaticHTML('');
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.match.params.staticPage !== this.props.match.params.staticPage
    ) {
      this.props.getStaticPage(nextProps.match.params.staticPage);
    }
  }

  render() {
    let { staticHTML } = this.props;
    let title = '';

    if (staticHTML) {
      staticHTML = ('`' + staticHTML + '`').replace(
        'http://jolipage.airstore.io/v3/themes/common/css/bootstrap.css',
        ''
      ).replace(
        'http://',
        'https://'
      ).replace(
        's/all/all/all',
        'search/all/all/all'
      );
      const titleRegExp = new RegExp('<title>(.*?)</title>');
      const match = titleRegExp.exec(staticHTML);

      title = match && match[1];
    }

    return (
      <Page id="static-page" title={title}>
        <div dangerouslySetInnerHTML={{ __html: staticHTML }} />
      </Page>
    );
  }
}

const mapStateToProps = state => ({
  session: state.auth.currentUser,
  staticHTML: state.staticPage.staticHTML
});

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ getStaticPage }, dispatch),
  setStaticHTML: html => dispatch(setStaticHTML(html))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false
  })(StaticPages)
);
